export default {
  name: 'bus-stop-selector',
  props: {
    value: {
      type: Object,
      default: null
    },
    items: {
      type: Array,
      default: function () { return [] }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    emptyText: {
      type: String,
      default: 'Select Stop'
    },
    searchPlaceholder: {
      type: String,
      default: 'Search or select stop name'
    },
    width: {
      type: [Number, String],
      default: 400
    },
    chipColor: {
      type: String,
      default: undefined
    }
  },
  data () {
    return {
      viewDialog: false,
      keyword: ''
    }
  },
  computed: {
    filteredItems () {
      const items = Array.isArray(this.items) ? this.items : []
      const kw = this.keyword ? String(this.keyword).trim() : ''
      if (!kw) return items

      const keywordParts = kw.split(' ').map((o) => o.trim()).filter(Boolean)
      return items.filter((o) => {
        const name = o && o.name ? String(o.name).toLowerCase() : ''
        return keywordParts.every((k) => name.indexOf(String(k).toLowerCase()) > -1)
      })
    }
  },
  methods: {
    open () {
      if (this.disabled) return
      this.keyword = ''
      this.viewDialog = true
    },
    clear () {
      this.$emit('input', null)
    },
    closeSelect (selectedItem) {
      this.$emit('input', selectedItem || null)
      this.viewDialog = false
    },
    isSelected (item) {
      return Boolean(this.value && item && this.value.id === item.id)
    }
  }
}
